import React, {Component, Fragment} from 'react';
import { connect }          from 'react-redux';


import './index.scss';

//components
import {acquireCoupon, getAvailabaleCoupons, setMembershipValidation} from "../../../../redux/actions";

//assets
import desktop_exit from 'assets/icons/login-x-icon.svg';
import {getMediaPath} from "../../../../app/functions";
import * as Popups from "../../../../constants/popup-types";


class CardCheck extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            first_try:true,
            allValid:false,
            form:{
                first:false,
                second:false,
                third:false,
                fourth:false
            },
        };
        this.animateOut  = this.animateOut.bind(this);
        this.animateIn   = this.animateIn.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }
    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleOnInput = (e) =>{
        if(e.target.previousSibling !== null){
            e.target.previousSibling.focus();
        }
        e.target.value = e.target.value.slice(0, 1);
        let new_state;
        if (e.target.value === '')
            new_state = {...this.state.form, [e.target.name]: false};
        else
            new_state = {...this.state.form, [e.target.name]: e.target.value};


        const form = new_state;
        let is_valid = true;
        for (let key in form) {
            if (form[key] === false)
                is_valid = false;
        }

        this.setState({form: new_state, allValid: is_valid});
    };

    handleSubmit(e) {
        e.preventDefault();
        const form = this.state.form;
        let payload = '';
        for (let key in form) {
            payload = payload.concat(form[key]);
        }

        if(this.state.allValid){
            switch (this.props.benefitType) {
                case 300:
                    if(this.props.benefit.isAcquired){
                        this.props.addPopup({
                            type: Popups.ACQUIRED,
                            benefitId: this.props.match.params.id,
                            isAcquired: true,
                            purchased: false,
                        });
                        this.props.handleClose();
                    } else{
                        this.props.acquireCoupon(
                            {code: payload, benefitId: this.props.benefitId},
                            this.props.benefit,
                            this.props.translations,
                            this.props.handleClose
                        );
                        this.props.handleClose();
                    }
                    break;
                case 800:
                case 1300:
                    this.props.getAvailableCoupons({code: payload, benefitId: this.props.benefitId});
                    break;
                default: break;
            }
        }
    }

    render() {

        const appStatus = this.props.benefitStatusDown;

        if(appStatus){
            return false;
        }

        const errMsg = this.props.acquiredErr ? this.props.acquiredErr.content : '';

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper card-check " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content">
                            <button className = "x_close_icon"
                                    onClick = { () => this.animateOut() }
                                    aria-label="סגור">
                                <img src={getMediaPath(desktop_exit)} alt='/'/>
                            </button>
                            {!appStatus &&
                            <Fragment>
                                <div className="subtitle">{'הזינו 4 ספרות אחרונות ' +
                                'של כ.אשראי מועדון הוט'}</div>
                                <form onSubmit={this.handleSubmit}>
                                    <div className='input-container'>
                                        <input type='number' pattern="[0-9]*" name='fourth' onInput={event => this.handleOnInput(event)} tabIndex={4}/>
                                        <input type='number' pattern="[0-9]*" name='third'  onInput={event => this.handleOnInput(event)} tabIndex={3}/>
                                        <input type='number' pattern="[0-9]*" name='second' onInput={event => this.handleOnInput(event)} tabIndex={2}/>
                                        <input type='number' pattern="[0-9]*" name='first'  onInput={event => this.handleOnInput(event)} tabIndex={1}/>
                                    </div>
                                    <button type="submit"
                                            className="green-button submit-button">{this.props.translations['check_card_btn']}</button>
                                    <span className='error-massage'>{errMsg}</span>
                                </form>
                            </Fragment>
                            }
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        benefitStatusDown: store.data.VIPBenefitDown,
        benefit: store.data.BenefitPage,
        errorMsg: store.data.vipBenefitErrMsg,
        translations: store.config.Translations,
        acquiredErr: store.data.BenefitAcquiredErr,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        sendValidation: (payload, route) =>dispatch(setMembershipValidation(payload, route)),
        acquireCoupon: (payload, benefit, translations, onClose) => dispatch(acquireCoupon(payload, benefit, translations, onClose)),
        getAvailableCoupons:(payload) => dispatch(getAvailabaleCoupons(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(CardCheck);
